var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex align-items-top" }, [
    _c("img", {
      staticClass: "round shadow",
      attrs: {
        src:
          _vm.data.owner.avatar != null
            ? _vm.data.owner.avatar.url
            : "/images/avatar.png",
        alt: "avatar",
        height: "25",
        width: "25",
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "card mb-1 d-inline-block ml-05",
        staticStyle: { width: "90%" },
      },
      [
        _c(
          "div",
          {
            staticClass: "d-flex align-items-center border-bottom  pb-05 m-05",
          },
          [
            _c("div", { staticClass: "pr-1" }, [
              _c(
                "a",
                {
                  staticClass: "text-bold-600 dark",
                  attrs: {
                    href: "/member/profiles/" + _vm.data.owner.username,
                  },
                  domProps: {
                    textContent: _vm._s(
                      _vm.data.owner.first_name + " " + _vm.data.owner.last_name
                    ),
                  },
                },
                [
                  _c("span", { staticClass: "text-bold-500 dark" }, [
                    _vm._v(" " + _vm._s(_vm.__("globals.wrote")) + ": "),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ml-auto" }, [
              _c("span", {
                staticClass: "text-muted font-small-2",
                domProps: { textContent: _vm._s(_vm.ago) },
              }),
              _vm._v(" "),
              _vm.canUpdate
                ? _c(
                    "button",
                    {
                      staticClass: "btn-sm btn-flat-danger",
                      staticStyle: { border: "none" },
                      on: { click: _vm.destroy },
                    },
                    [_c("i", { staticClass: "fa fa-trash-o" })]
                  )
                : _vm._e(),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ml-1 mr-1 mb-1 mt-05" }, [
          _c("span", { class: "rating-static rating-" + _vm.data.rating * 10 }),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n                " + _vm._s(_vm.rating) + "\n            "
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }